import {Injectable} from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EventBrokerService {

  public event = new Subject<string>()

  public eventObserveble$= this.event.asObservable()

  constructor() {
  }

  public sendEvent(eventType: string) {
    this.event.next(eventType)
  }
}
